import { ref } from 'vue';
import Emitter from 'tiny-emitter';

const emitter = new Emitter();

export function useEventBus() {
  const emitEvent = (eventName, eventData) => {
    emitter.emit(eventName, eventData);
  };

  const onEvent = (eventName, callback) => {
    emitter.on(eventName, callback);
    return () => {
      emitter.off(eventName, callback);
    };
  };

  const offEvent = (eventName, callback) => {
    emitter.off(eventName, callback);
  };

  return {
    emitEvent,
    onEvent,
    offEvent
  };
}
